/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Image) GS.Toolbar.Image={};
GS.Toolbar.Image.AlignTools=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.Image.AlignTools',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{'x':'X','y':'Y','o':'O','b':'B'},
        'toolbar':null
    },
    controlled:null,
   
    initialize:function(conf){
       this.options.lexico=Locale.get('Toolbar.align');
       this.parent(conf);
    },

    /**
     *
     * @param {Object} permissions
     * @returns {void}
     */
    updatePermissions: function(permissions){
        var vis=false,
            self=this,
            use=this.options.permission_property;

        //console.warn('UPDATE PERMISSION IN ALIGN TOOLS', permissions, use, typeof permissions[use]);


        if(!use.pop) use=[use];
        Array.each(use,function(prop,i){
            if(typeof permissions[prop]==='object'){
                Object.each(permissions[prop],function(v,p){
                    if(v) vis=true;
                    self.fireEvent(p,v);
                });
            }else{
                if(permissions[prop]===true) vis=true;
                self.fireEvent(prop,permissions[prop]);
            }
        });

        if(vis){
            this.options.wrapper.querySelector('[data-type="align-top"]').style.display ='block';
            this.options.wrapper.querySelector('[data-type="align-vcenter"]').style.display ='block';
            this.options.wrapper.querySelector('[data-type="align-bottom"]').style.display ='block';
            this.options.wrapper.querySelector('[data-type="align-left"]').style.display ='block';
            this.options.wrapper.querySelector('[data-type="align-hcenter"]').style.display ='block';
            this.options.wrapper.querySelector('[data-type="align-right"]').style.display ='block';
            this.options.wrapper.querySelector('[data-type="align-top"]').parentNode.style.width = 184 + 'px';
        }

        if(vis && typeof permissions[use] === "object"){
            //console.warn(this.options.wrapper,  permissions[use], this);
            var bWidth = 4;
            this.options.wrapper.querySelector('[data-type="align-top"]').style.display= permissions[use]['align-top'] ? 'block' :'none';
            this.options.wrapper.querySelector('[data-type="align-vcenter"]').style.display= permissions[use]['align-vcenter'] ? 'block' :'none';
            this.options.wrapper.querySelector('[data-type="align-bottom"]').style.display= permissions[use]['align-bottom'] ? 'block' :'none';
            this.options.wrapper.querySelector('[data-type="align-left"]').style.display= permissions[use]['align-left'] ? 'block' :'none';
            this.options.wrapper.querySelector('[data-type="align-hcenter"]').style.display= permissions[use]['align-hcenter'] ? 'block' :'none';
            this.options.wrapper.querySelector('[data-type="align-right"]').style.display= permissions[use]['align-right'] ? 'block' :'none';
            if(permissions[use]['align-top']) bWidth += 30;
            if(permissions[use]['align-vcenter']) bWidth += 30;
            if(permissions[use]['align-bottom']) bWidth += 30;
            if(permissions[use]['align-left']) bWidth += 30;
            if(permissions[use]['align-hcenter']) bWidth += 30;
            if(permissions[use]['align-right']) bWidth += 30;
            this.options.wrapper.querySelector('[data-type="align-top"]').parentNode.style.width = bWidth + 'px';

        }


        //if(permissions.delete) vis = true;
        //console.info('Toolbar is visible: %s', vis, permissions, use);
        this.options.wrapper.setStyle('display',(vis) ? 'block' : 'none');
        if(vis) this.toolbar.fireEvent('show');
    }
});


GS.Toolbar.Image.AlignTools.prototype.menuTMPL=function(){
    //var out='    <li class="slider effect-brightness" data-type="effect-brightness" data-uitype="slider"><label>{l}</label></li>';
    var out;
    out='       <li class="align-top" data-type="align-top" title="{top}"></li>';
    out+='      <li class="align-hcenter" data-type="align-hcenter" title="{center_v}"></li>';
    out+='      <li class="align-bottom" data-type="align-bottom" title="{bottom}"></li>';
    out+='      <li class="separator"></li>';
    out+='      <li class="align-left"  data-type="align-left" title="{left}"></li>';

    out+='      <li class="align-vcenter" data-type="align-vcenter" title="{center_h}"></li>';
    out+='      <li class="align-right" data-type="align-right" title="{right}"></li>';
    out=out.substitute(Locale.get('Toolbar.align'));
    
    return out;
};